import { getAuth } from "firebase/auth";
import { app } from "configs/FirebaseConfig";

const auth = getAuth(app);
const currentUser = auth.currentUser;

export { auth, currentUser };
